/* If you edit this file, please remove this header and clean up the resulting eslint errors.
*/
/* eslint-disable
  no-console,
*/
import React from 'react';
import PropTypes from 'prop-types';
import HfReactHelper from 'common/utils/hf-react-helper';
import './dropbox-signin-button.scss';
import superagent from 'superagent';
import { stringify } from 'qs';
import DropboxSvg from '../../../../public/images/v2/modules/home/integrations/dropbox_icon.svg';

export default class DropboxSignInButton extends React.Component {
  static propTypes = {
    redirectUrl: PropTypes.string,
    csrfToken: PropTypes.string.isRequired,
    formType: PropTypes.string,
  };

  static dropboxAuthUrl = HfReactHelper.urlHelper('account/DropboxAuth');

  constructor(...args) {
    super(...args);

    this.state = {
      renderStatus: 'ok',
      errorText: '',
      isProcessing: false,
    };
  }

  onSignIn = () => {
    if (this.state.isProcessing) {
      return;
    }

    const postBody = {
      form_type: this.props.formType,
      redirect_url: this.props.redirectUrl,
      csrf_token: this.props.csrfToken,
    };

    this.setState({ renderStatus: 'ok', isProcessing: true });

    superagent
      .post(DropboxSignInButton.dropboxAuthUrl)
      .type('form')
      .send(stringify(postBody))
      .end((err, response) => {
        if (err || !response.ok) {
          // Error here means some kind of http status error (4xx or 5xx)
          this.onSignInFailure();
        }

        try {
          const responseObj = JSON.parse(response.text);
          const redirectTo = responseObj.auth_url;
          window.location.replace(redirectTo);
        } catch (e) {
          this.onSignInFailure();
        }
      });
  };

  onSignInFailure = () => {
    this.setState({
      renderStatus: 'failure',
      errorText: 'There was a problem, please try again.',
      isProcessing: false,
    });
  };

  shouldShowErrorText() {
    return this.state.renderStatus === 'failure';
  }

  render() {
    return (
      <div className={`dropbox-signin-button${this.state.isProcessing ? ' dropbox-signin-button--is-processing' : ''}`}>
        <button className="dropbox-signin-button__button" onClick={this.onSignIn}>
          <div className="dropbox-signin-button__left">
            <img src={DropboxSvg} className="dropbox-signin-button__icon" alt="" aria-hidden="true" />
          </div>
          <div className="dropbox-signin-button__right">Sign in with Dropbox{this.state.isProcessing ? '…' : ''}</div>
        </button>
        {this.shouldShowErrorText() ? (
          <div className="dropbox-signin-button__error">
            {this.state.errorText}
          </div>
        ) : null}
      </div>
    );
  }
}
